import { Reducer } from "redux";

import { EMPTY_OBJECT } from "@multiweb/reactUtils";
import { IPublicAttributeInfo } from "@multiweb/types/contracts";
import { MutableTypedObject, TypedObject } from "@multiweb/types/react";
import { DATA_SOURCE_INIT_STATE } from "../initState";
import {
    ILoadAttributeInfoErrorAction,
    ILoadAttributeInfoSuccessAction,
} from "../types";

export const attributeInfoReducer: Reducer<TypedObject<IPublicAttributeInfo>> = (
    state = DATA_SOURCE_INIT_STATE.attributeInfo,
    action,
) => {
    if (action instanceof ILoadAttributeInfoSuccessAction) {
        const newInfo: MutableTypedObject<IPublicAttributeInfo> = {};
        action.payload.attributeInfo.forEach((info) => (newInfo[info.attributeName.toLowerCase()] = info));
        return newInfo;
    } else if (action instanceof ILoadAttributeInfoErrorAction) {
        return EMPTY_OBJECT;
    }
    return state;
};
